import React from "react";
import A4InvoiceTemplate from "./A4InvoiceTemplate";
import ThermalInvoiceTemplate from "./ThermalInvoiceTemplate";

// Dispatcher: picks the A4 or thermal template based on layout.template.
const PrintableInvoice = ({ layout = {}, invoice = {}, storeInfo = {}, editing = false, onEditField }) => {
  if (layout.template === "thermal") {
    return <ThermalInvoiceTemplate layout={layout} invoice={invoice} storeInfo={storeInfo} />;
  }
  return (
    <A4InvoiceTemplate
      layout={layout}
      invoice={invoice}
      storeInfo={storeInfo}
      editing={editing}
      onEditField={onEditField}
    />
  );
};

export default PrintableInvoice;
